import { clearLocalStorageAndSetLogoutTime } from "./helper";

// const poolData = {
//   UserPoolId: "YOUR_USER_POOL_ID",
//   ClientId: "YOUR_APP_CLIENT_ID",
// };
// const userPool = new CognitoUserPool(poolData);
// const userPool = poolData;

export const refreshSession = (callbackFunction, dispatch) => {
  console.log("run refresh");
  // const cognitoUser = userPool.getCurrentUser();

  // const logout = () => {
  //   "reloadSession";
  //   clearLocalStorageAndSetLogoutTime();
  //   cognitoUser?.signOut();
  //   window.location.reload();
  // };

  const getStoredRefreshToken = () => {
    const stored = localStorage.getItem("refreshToken");
    if (!stored) return null;
    try {
      const parsed = JSON.parse(stored);
      if (typeof parsed === "string") return parsed;
      if (parsed?.token) return parsed.token;
      if (parsed?.jwtToken) return parsed.jwtToken;
      return null;
    } catch (e) {
      return stored;
    }
  };

  const refreshToken = getStoredRefreshToken();

  if (!refreshToken) {
    clearLocalStorageAndSetLogoutTime();
    // cognitoUser?.signOut();
    window.location.href = "/auth/login";
    // window.location.reload();
    return;
  }

  console.log(refreshToken);

  // console.log(refreshToken);

  fetch("https://weu658vyjj.execute-api.ap-southeast-2.amazonaws.com/dev/api", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      operation_mode: "refresh_token",
      refresh_token: refreshToken,
    }),
  })
    .then((res) => res.json())
    .then((data) => {
      if (!data?.access_token) {
        clearLocalStorageAndSetLogoutTime();
        // cognitoUser?.signOut();
        window.location.href = "/auth/login";
        console.error(
          "Failed to refresh session:",
          data?.message || "No access token in response",
        );

        // logout();
        return;
      }

      const newAccessToken = data.access_token;
      console.log(newAccessToken);

      localStorage.setItem(
        "aws-amplify-federatedInfo",
        JSON.stringify({ token: newAccessToken }),
      );
      // localStorage.setItem("refreshToken", newAccessToken);
      //
      //
      //
      const redirectPath =
        localStorage.getItem("postRefreshRedirect") || "/dashboard";
      localStorage.removeItem("postRefreshRedirect");

      window.location.href = redirectPath;

      // const newIdToken = data.id_token;
      // console.log("Tokens refreshed:", { newAccessToken, newIdToken });
      // dispatch(callbackFunction());

      // window.history.back();
    })
    .catch((err) => {
      console.log("error logout");
      clearLocalStorageAndSetLogoutTime();
      // cognitoUser?.signOut();
      window.location.href = "/auth/login";
      console.error("Failed to refresh session:", err);

      // logout();
      return;
    });
};
